export default __webpack_public_path__ + "src/images/galleries/2/btn_back-78aa16.png";